import { BrandSectionFilesGroupController } from './brand-section-files-group.controller'

function brandSectionFilesGroup () {
  return {
    restrict: 'E',
    scope: {
      section: '=',
      category: '='
    },
    templateUrl: '/brand/directives/brand-section-files-group/brand-section-files-group-directive.html?$$REVISION$$',
    controller: BrandSectionFilesGroupController
  }
}

export { brandSectionFilesGroup }
